<div class="identity-sheet">
  <div class="identity-sheet__header">
    <h2 class="identity-sheet__title"><mat-icon>person</mat-icon> Identifiants & sécurité</h2>
    <button mat-icon-button (click)="close()" aria-label="Fermer"><mat-icon>close</mat-icon></button>
  </div>

  <div class="identity-sheet__content">
    <!-- Email -->
    <div class="sheet-row">
      <mat-icon class="sheet-row__icon">email</mat-icon>
      <div class="sheet-row__body">
        <span class="sheet-row__label">Adresse email</span>
        <span class="sheet-row__value">{{ account.email }}</span>
      </div>
    </div>

    <!-- Pseudo -->
    <div class="sheet-row">
      <mat-icon class="sheet-row__icon">badge</mat-icon>
      <div class="sheet-row__body">
        <span class="sheet-row__label">Pseudo</span>
        <mat-form-field appearance="outline" class="sheet-row__field">
          <mat-label>Anonyme_{{ account.id }}</mat-label>
          <input matInput placeholder="Pseudo" type="text" maxlength="15"
                 [(ngModel)]="account.username" (ngModelChange)="setUsername($event)">
          <mat-hint>{{ (account.username) ? account.username.length : 0 }}/15</mat-hint>
          <button matSuffix mat-icon-button (click)="saveUsername()"
                  [ngClass]="(usernameValidation === null) ? '' : (usernameValidation) ? 'validation-green' : 'validation-red'">
            <mat-icon>{{ (usernameValidation === null) ? 'check_circle_outline' : (usernameValidation) ? 'verified' : 'error' }}</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <!-- Téléphone -->
    <div class="sheet-row" *ngIf="!editingPhone">
      <mat-icon class="sheet-row__icon">phone</mat-icon>
      <div class="sheet-row__body">
        <span class="sheet-row__label">Téléphone</span>
        <span class="sheet-row__value" *ngIf="isPhoneSet()">
          ({{ account.phone.regionCode }}) {{ account.phone.number.national }}
        </span>
        <span class="sheet-row__value sheet-row__value--muted" *ngIf="!isPhoneSet()">Non renseigné</span>
      </div>
      <button mat-icon-button (click)="startEditPhone()" aria-label="Modifier le téléphone">
        <mat-icon>edit</mat-icon>
      </button>
    </div>

    <!-- Téléphone édition -->
    <div class="sheet-edit" *ngIf="editingPhone">
      <form [formGroup]="profileForm">
        <div formGroupName="phone" class="sheet-edit__phone">
          <mat-form-field appearance="outline" class="sheet-edit__phone-country">
            <mat-label>Pays</mat-label>
            <mat-select formControlName="country" (selectionChange)="formatNumber()"
                        [value]="(account.phone !== null) ? account.phone.regionCode : ''">
              <mat-option *ngFor="let c of countyCodes" [value]="c.code">{{ c.country }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="sheet-edit__phone-number">
            <mat-label>N° téléphone</mat-label>
            <input formControlName="number" type="tel" matInput
                   [value]="(account.phone !== null && account.phone.number !== null) ? account.phone.number.national : ''"
                   (input)="formatNumber()" [errorStateMatcher]="phoneErrorMatcher">
            <mat-error *ngIf="!phoneGroup.valid">Numéro valide: {{ phoneHint }}</mat-error>
            <mat-hint>{{ phoneHint }}</mat-hint>
          </mat-form-field>
        </div>
      </form>
      <div class="sheet-edit__actions">
        <button mat-stroked-button color="warn" (click)="cancelEditPhone()"><mat-icon>close</mat-icon> Annuler</button>
        <button mat-flat-button color="primary" (click)="validatePhoneNumber()"><mat-icon>check</mat-icon> Valider</button>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Actions sécurité -->
    <button mat-stroked-button class="sheet-action" (click)="openPasswordDialog()">
      <mat-icon>lock</mat-icon> Modifier mon mot de passe
      <mat-icon *ngIf="!isPasswordChanged()" color="warn" class="sheet-action__warn">error</mat-icon>
    </button>
  </div>
</div>
